import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO__word_with_context extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.WORD_WITH_CONTEXT;

  static from_string(word: string): DTO__word_with_context {
    let out = new DTO__word_with_context();

    out.word = word;

    return out;
  }

  static get_words_without_translations(tokens: DTO__token[], language: string): DTO__word_with_context[] {
    let out = [];

    for (let token_to_translate of tokens) {
      if (token_to_translate.word.language == language && token_to_translate.word.word_translated) continue; //already translated

      let word_with_context = new DTO__word_with_context();
      word_with_context.word = token_to_translate.word_english;
      word_with_context.context = tokens.filter(token => token.word_english != token_to_translate.word_english).map(token => token.word_english);

      out.push(word_with_context);
    }

    return out;
  }

  /*
   * INSTANCE FIELDS
   */

  word!: string;
  context!: string[];

  /*
   * METHODS
   */

  constructor() {
    super();

    this.context = [];
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.word);
  }
}
